import { render, staticRenderFns } from "./NewsletterSettings.vue?vue&type=template&id=86a7ddcc&scoped=true&"
import script from "./NewsletterSettings.vue?vue&type=script&lang=js&"
export * from "./NewsletterSettings.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./NewsletterSettings.vue?vue&type=style&index=1&id=86a7ddcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a7ddcc",
  null
  
)

export default component.exports